// Hjelpere for prisforslaget i «Nytt oppdrag».

const nb = n => Math.round(n).toLocaleString('nb-NO');

// ±10 % rundet til nærmeste 100 (nærmeste 10 under kr 1 000).
export function suggestedPriceRange(suggested) {
  const s = Number(suggested);
  if (!Number.isFinite(s) || s <= 0) return null;
  const step = s >= 1000 ? 100 : 10;
  const round = v => Math.round(v / step) * step;
  return { low: round(s * 0.9), high: round(s * 1.1) };
}

// «Prisforslag: 3 900–4 600 for 14 tonn og 14 km»
export function priceHint({ suggested, tons, unit, distKm }) {
  const range = suggestedPriceRange(suggested);
  if (!range || distKm == null) return null;
  const qty = Number(tons).toLocaleString('nb-NO');
  const what = unit === 'bags' ? 'sekker' : 'tonn';
  return `Prisforslag: ${nb(range.low)}–${nb(range.high)} for ${qty} ${what} og ${Math.round(distKm)} km`;
}

// Fastprisfeltet følger forslaget til brukeren selv endrer det.
export function nextAutoPrice({ edited, suggested, current }) {
  if (edited) return current;
  const s = Math.round(Number(suggested));
  if (!Number.isFinite(s) || s <= 0) return current;
  return String(s);
}

// Grov kjøretid fra luftlinje: ×1,3 til vei, ca. 45 km/t, rundet til 5 min (minst 5).
export function estimateMinutes(distKm) {
  if (distKm == null || !Number.isFinite(distKm)) return null;
  const minutes = (distKm * 1.3 / 45) * 60;
  return Math.max(5, Math.round(minutes / 5) * 5);
}
